import { useTranslation } from 'react-i18next';

import { ThemeToggle } from '@/components/theme-toggle';

type LeftPanelProps = {
  /** When true, shows logo + welcome copy overlaid on the image (Welcome screen only) */
  showWelcomeContent?: boolean;
};

export default function LeftPanel({ showWelcomeContent = false }: LeftPanelProps) {
  const { t } = useTranslation();
  return (
    <div className='hidden lg:flex relative w-[52%] flex-shrink-0 min-h-screen overflow-hidden'>
      <ThemeToggle fixed />
      {/* Light mode image */}
      <img
        src={`${import.meta.env.BASE_URL}images/light.png`}
        alt=''
        className='absolute inset-0 w-full h-full object-cover dark:hidden'
        aria-hidden='true'
      />

      {/* Dark mode image */}
      <img
        src={`${import.meta.env.BASE_URL}images/dark.png`}
        alt=''
        className='absolute inset-0 w-full h-full object-cover hidden dark:block'
        aria-hidden='true'
      />

      {/* Gradient: fades image into page background on the right edge */}
      <div className='absolute inset-0 bg-gradient-to-r from-transparent to-ws-bg' />

      {/* Welcome content overlay (Welcome screen only) */}
      {showWelcomeContent && (
        <div className='relative z-10 flex flex-col items-center justify-center w-full gap-6 px-12 text-center'>
          <img
            src={`${import.meta.env.BASE_URL}images/agavi-logo.svg`}
            alt='Agavi'
            className='w-24 h-24'
          />
          <div className='space-y-3'>
            <h1 className='text-5xl font-semibold text-ws-text leading-tight'>
              {t('auth.welcome.title')}
            </h1>
            <p className='text-lg text-ws-muted max-w-xs mx-auto'>
              {t('auth.welcome.subtitle')}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
